import React from "react"
import {
  withStyles,
  WithStyles,
  createStyles,
  Divider,
} from "@material-ui/core"

const styles = () => {
  return createStyles({
    root: {
      opacity: 0.5,
    },
  })
}

interface Props extends WithStyles<typeof styles> {}

const CardDivider = ({ classes }: Props) => {
  return <Divider classes={classes} />
}

export default withStyles(styles)(CardDivider)
